<template>
<div class="chapter">
<div class="inner_page">
<p class="c6"><em class="calibre8"><a class="calibre9" id="page_13"></a>Part One</em></p>
<p class="c7">1946</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0005.vue?7cfdb190